(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super()
    }

    handleClick(e) {
      e.preventDefault()
      const {closeAnnouncement} = e.target.dataset
      if (closeAnnouncement === 'row') {
        e.target.closest('.announcement-bar__row').remove()
      } else {
        this.remove()
      }
    }

    connectedCallback() {
      if (this.querySelector('.announcement-bar__close')) {
      this.querySelector('.announcement-bar__close').addEventListener('click', this.handleClick.bind(this))
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calorie-calculator"] && !window.DesignMode) return;
  try {
    
  /****************************************
   * 1) DATENSTRUKTUREN (Eissorten, Behälter, Toppings)
   ****************************************/
  const flavors = {
    "Vanille":    { cal: 150, sugar: 18, protein: 3 },
    "Schokolade": { cal: 170, sugar: 20, protein: 4 },
    "Erdbeere":   { cal: 140, sugar: 17, protein: 3 }
    // ... beliebig erweitern
  };

  const containers = {
    "cup":  { cal: 20, sugar: 2, protein: 1 },
    "cone": { cal: 50, sugar: 5, protein: 2 }
  };

  const toppings = {
    "cream":     { cal: 50, sugar: 4,  protein: 1 }, 
    "sprinkles": { cal: 30, sugar: 5,  protein: 0 }
  };

  // HTML-Referenzen
  const numScoopsSelect = document.getElementById('numScoops');
  const containerTypeSelect = document.getElementById('containerType');
  const flavorContainer = document.getElementById('flavorContainer');
  const calcBtn = document.getElementById('calcBtn');
  const resultDiv = document.getElementById('result');
  const caloriesSpan = document.getElementById('calories');
  const sugarSpan = document.getElementById('sugar');
  const proteinSpan = document.getElementById('protein');

  /****************************************
   * 2) GENERIERUNG DER EISSORTEN-FELDER
   ****************************************/
  function generateFlavorSelectors(count) {
    flavorContainer.innerHTML = '';
    for (let i = 0; i < count; i++) {
      // Container für eine Zeile
      const wrapper = document.createElement('div');
      wrapper.classList.add('calc-group');

      const label = document.createElement('label');
      label.textContent = `Sorte für Kugel ${i + 1}:`;
      label.style.fontWeight = '600';

      const select = document.createElement('select');
      select.name = `flavor${i}`;
      select.style.width = '100%';

      // Jede Sorte als Option
      for (let flavorName in flavors) {
        const option = document.createElement('option');
        option.value = flavorName;
        option.textContent = flavorName;
        select.appendChild(option);
      }

      wrapper.appendChild(label);
      wrapper.appendChild(select);
      flavorContainer.appendChild(wrapper);
    }
  }

  // Initial: 1 Kugel
  generateFlavorSelectors(parseInt(numScoopsSelect.value, 10));

  // Bei Änderung der Kugelanzahl
  numScoopsSelect.addEventListener('change', (e) => {
    generateFlavorSelectors(parseInt(e.target.value, 10));
  });

  /****************************************
   * 3) BERECHNUNG
   ****************************************/
  calcBtn.addEventListener('click', () => {
    let totalCal   = 0;
    let totalSugar = 0;
    let totalProt  = 0;

    // Behälter
    const selectedContainer = containers[containerTypeSelect.value];
    totalCal   += selectedContainer.cal;
    totalSugar += selectedContainer.sugar;
    totalProt  += selectedContainer.protein;

    // Kugeln
    const scoopCount = parseInt(numScoopsSelect.value, 10);
    const flavorSelects = flavorContainer.getElementsByTagName('select');
    for (let i = 0; i < scoopCount; i++) {
      const flavorName = flavorSelects[i].value;
      const flv = flavors[flavorName];
      totalCal   += flv.cal;
      totalSugar += flv.sugar;
      totalProt  += flv.protein;
    }

    // Toppings
    const toppingBoxes = document.querySelectorAll('input[name="topping"]:checked');
    toppingBoxes.forEach(box => {
      const topData = toppings[box.value];
      totalCal   += topData.cal;
      totalSugar += topData.sugar;
      totalProt  += topData.protein;
    });

    // Ergebnisanzeige
    caloriesSpan.textContent = totalCal;
    sugarSpan.textContent = totalSugar + 'g';
    proteinSpan.textContent = totalProt + 'g';
    resultDiv.style.display = 'block';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
class FooterCollapsible extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.summaryIsEmpty = this.summary.textContent.trim().length == 0;
		this.openDefault = this.dataset.openDefault === 'true'

    this.details.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    document.addEventListener('matchMobile', this.close.bind(this));
    document.addEventListener('unmatchMobile', this.open.bind(this));

    if (FoxThemeSettings.isMobile) {
			if (!this.openDefault) this.close()
    }

		document.addEventListener('matchMobile', () => {
			if (!this.openDefault) {
				this.close()
			} else {
				this.open()
			}
		})

		document.addEventListener('unmatchMobile', () => {
			this.open()
		})
		
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open();
  }

  open() {
    this.details.setAttribute('open', true);
  }

  close() {
    !this.summaryIsEmpty && this.details.removeAttribute('open');
  }
}

customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderMenu extends DetailsDisclosure {
    constructor() {
      super();
      this.header = document.querySelector('.site-header__wrapper');
    }

    onToggle() {
      if (!this.header) return;
      this.header.preventReveal = this.mainDetailsToggle.open;
    }
  }
  customElements.define('header-menu', HeaderMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super()
      document.body.classList.add('mobile-sticky-bar-enabled')
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar)


  } catch(e) { console.error(e); }
})();
})();
